import { EmojiType } from '../types';

/**
 * Emoji configuration for sentiment-based feedback options.
 * Uses MUI icons similar to airport feedback terminals.
 */
export interface EmojiConfig {
  type: EmojiType;
  label: string;
  description: string;
  iconName: string;
}

/**
 * Ordered list of sentiment emojis from positive to negative.
 * This order is used for displaying the emoji picker.
 */
export const EMOJI_OPTIONS: EmojiConfig[] = [
  {
    type: 'very_satisfied',
    label: 'Very Happy',
    description: 'Very satisfied or highly positive',
    iconName: 'SentimentVerySatisfied',
  },
  {
    type: 'satisfied',
    label: 'Happy',
    description: 'Satisfied or positive',
    iconName: 'SentimentSatisfied',
  },
  {
    type: 'neutral',
    label: 'Neutral',
    description: 'Neutral or undecided',
    iconName: 'SentimentNeutral',
  },
  {
    type: 'dissatisfied',
    label: 'Unhappy',
    description: 'Dissatisfied or negative',
    iconName: 'SentimentDissatisfied',
  },
  {
    type: 'very_dissatisfied',
    label: 'Very Unhappy',
    description: 'Very dissatisfied or highly negative',
    iconName: 'SentimentVeryDissatisfied',
  },
];

/**
 * Map of emoji types to their configurations for quick lookup.
 */
export const EMOJI_CONFIG_MAP: Record<EmojiType, EmojiConfig> = EMOJI_OPTIONS.reduce(
  (acc, config) => {
    acc[config.type] = config;
    return acc;
  },
  {} as Record<EmojiType, EmojiConfig>
);

/**
 * Gets the emoji configuration for a given emoji type.
 * @param type - The emoji type
 * @returns The emoji configuration or undefined if not found
 */
export const getEmojiConfig = (type: EmojiType | undefined): EmojiConfig | undefined => {
  if (!type) return undefined;
  return EMOJI_CONFIG_MAP[type];
};
